import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileMarkdownTwoToneSvg from "@ant-design/icons-svg/es/asn/FileMarkdownTwoTone";
import AntdIcon from "../components/AntdIcon";
var FileMarkdownTwoTone = function FileMarkdownTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileMarkdownTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileMarkdownTwoTone.displayName = 'FileMarkdownTwoTone';
}
export default /*#__PURE__*/React.forwardRef(FileMarkdownTwoTone);